import api from '@/utils/api';

/**
 * get Dealers suppliers api
 * @returns {Promise} The promise object of the api call
 */
const getDealerSupplierApi = () => api.get(`dealer/supplier`);
export default getDealerSupplierApi;
